import { render } from "./AddTrainCourse.vue?vue&type=template&id=619f515d"
import script from "./AddTrainCourse.vue?vue&type=script&lang=js"
export * from "./AddTrainCourse.vue?vue&type=script&lang=js"
script.render = render

export default script